import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const rows = [{
  format: '📖 PDF alta calidad',
  content: 'Los 6 Tomos del Sistema',
  pages: '+200 páginas'
}, {
  format: '📋 PDF optimizado móvil',
  content: 'Kit de Implementación Pocket',
  pages: '+50 páginas'
}, {
  format: '💪 PDF imprimible',
  content: 'Los 5 Bonos completos',
  pages: '+60 páginas'
}, {
  format: '🗂️ PDF A4',
  content: 'Fichas de Evaluación',
  pages: '+30 páginas'
}];
const checks = ['PDF de alta calidad', 'Imprimible en A4', 'Optimizado para tablet y móvil', 'Acceso inmediato sin esperas'];
export function InstantAccess() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-154" data-mp="2lnnftlcg8mof">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-155" data-mp="2gmzrx8jiolyf">
        <SectionTag icon="📦" data-id="element-156" data-mp="2gpc6rctzag79">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-157" data-mp="2cmpa8ymd473q">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-158" data-mp="3af55o0n0afnt">
          +350 páginas de material profesional descargables al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl px-4 sm:px-6" data-id="element-159" data-mp="30plnyyb14ruj">
        <ScrollHintTable minWidth="520px" data-id="element-160" data-mp="30pvcehgfeqy4">
          <table className="w-full text-left text-sm" data-id="element-161" data-mp="3offxp701y0ak">
            <thead data-id="element-162" data-mp="3ofzeulhvoknj">
              <tr className="border-b border-white/10 bg-white/5 text-xs uppercase tracking-wide text-muted" data-id="element-163" data-mp="3oddaeuqaal9j">
                <th className="px-5 py-3 font-semibold" data-id="element-164" data-mp="3fei1vbzroz32">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-165" data-mp="3fe8c9pimwtxw">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-166" data-mp="3jf21cm7tcesd">Páginas</th>
              </tr>
            </thead>
            <tbody data-id="element-167" data-mp="23yjoivxk3qw1">
              {rows.map((row, i) => <tr key={row.content} className={i !== rows.length - 1 ? 'border-b border-white/5' : ''} data-id="element-168" data-mp="280oglq8cwfgk" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-white" data-id="element-169" data-mp="eiquh7ehhbjp">{row.format}</td>
                  <td className="px-5 py-4 text-muted" data-id="element-170" data-mp="9je8eovfs8i6">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-orange" data-id="element-171" data-mp="9l7eo3250qpn">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-172" data-mp="3vwuwaer03n99">
          {checks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-white" data-id="element-173" data-mp="3my0sa3bcbulo">
              <CheckIcon size={16} className="text-success" data-id="element-174" data-mp="3n0djl72znhbe" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}